<template>
  <div>
    <NuxtLayout>
      <div>
        <NuxtPage />
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

let authCleanup = null

// Check for any navigation blockers
const debugNavigationHandlers = () => {
  if (typeof window === 'undefined') return;
  
  console.log('[APP] Checking for navigation blockers');
  
  // Log event listeners on window (not fully supported in all browsers)
  if (window.getEventListeners) {
    console.log('Window click listeners:', window.getEventListeners('click'));
  }
  
  // Check if window.navigate exists and what it is
  if (window.navigate) {
    console.log('Window navigate function exists:', window.navigate);
    
    // If window.navigate is a simple function that prevents navigation, replace it
    if (window.navigate.toString().includes('{}) => {}') || 
        window.navigate.toString().includes('e=>{}') ||
        window.navigate.toString().includes('e = {}')) {
      console.log('[APP] Found suspicious navigate handler, removing it');
      window.navigate = undefined;
    }
  }
  
  // Add a navigation monitor
  const originalNavigate = window.navigate;
  window.navigate = function(...args) {
    console.log('[APP] Navigation intercepted with args:', args);
    return originalNavigate ? originalNavigate.apply(this, args) : undefined;
  };
  
  // Check for any click handlers that might be preventing navigation
  const removePreventClickHandlers = () => {
    document.querySelectorAll('a').forEach(link => {
      const clonedLink = link.cloneNode(true);
      link.parentNode.replaceChild(clonedLink, link);
    });
    console.log('[APP] Removed and recreated all links to clear potential handlers');
  };
  
  // Call this after 2 seconds to ensure the app is fully loaded
  setTimeout(removePreventClickHandlers, 2000);
}

// Initialize Auth State
onMounted(async () => {
  // Get current route if in browser
  const currentRoute = typeof window !== 'undefined' ? window.location.pathname : 'server-side'
/*  console.log(`[APP] Starting auth initialization in app.vue at path: ${currentRoute}`, {
    url: typeof window !== 'undefined' ? window.location.href : 'server-side',
    timestamp: new Date().toISOString()
  })*/
  
  const { initialize, isAuthenticated } = useAuth()
  authCleanup = await initialize()
  
/*  console.log('[APP] Auth initialization complete', {
    isAuthenticated: isAuthenticated.value,
    path: typeof window !== 'undefined' ? window.location.pathname : 'server-side',
    timestamp: new Date().toISOString()
  })*/
  
  // Debug navigation issues
  // debugNavigationHandlers();
})

// Register cleanup before any async operations
onUnmounted(() => {
  console.log('[APP] Cleaning up auth listener')
  if (typeof authCleanup === 'function') {
    authCleanup()
  }
})
</script>

<style>
/* Import Cinzel font */
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap');
</style> 